import React, { useState } from 'react'
import { useUpdateEffect } from 'genesis-suite/hooks'
import { v1 as uuid } from 'uuid'
import produce from 'immer'
import PropertySelector from './PropertySelector'
import EditableList from '../EditableList'

const PropertySelectorController = props => {
    const {
        defaultRows,
        elementOptions,
        allOptions,
        onChange
    } = props

    const [selectorRows, setSelectorRows] = useState(defaultRows)
    const [availableElements, setAvailableElements] = useState(elementOptions)

    useUpdateEffect(() => {
        const newOptions = elementOptions && elementOptions.filter(opt => !selectorRows.some(obj => obj.node === opt.value))
        setAvailableElements(newOptions)
        onChange(selectorRows)
    }, [selectorRows])

    if (!elementOptions) return null

    const propsByElementId = allOptions.reduce((acc, obj) => ({
        ...acc,
        [obj.id]: obj.propertyOptions
    }), {})

    const handleChange = (val, id, type) => {
        if (type === 'element') {
            /* eslint-disable no-unused-vars */
            setSelectorRows(produce(selectorRows, draft => {
                draft = draft.map(row => {
                    if (row.id === id) row.node = val
                    return row
                })
            }))
        } else {
            setSelectorRows(produce(selectorRows, draft => {
                draft = draft.map(row => {
                    if (row.id === id) row.properties = val
                    return row
                })
            }))
        }
    }

    const handleRowRemove = i => setSelectorRows(produce(selectorRows, draft => { draft.splice(i, 1) }))
    const handleRowAdd = () => setSelectorRows([...selectorRows, { id: uuid(), node: null, properties: null }])

    return (
        <EditableList onRemove={handleRowRemove} onAdd={handleRowAdd}>
            {selectorRows.map(selectorObj => (
                <PropertySelector
                    key={selectorObj.id}
                    id={selectorObj.id}
                    elementOptions={availableElements}
                    propsByElementId={propsByElementId}
                    defaultElement={selectorObj.node}
                    defaultProperties={selectorObj.properties}
                    onChange={handleChange}
                />
            ))}
        </EditableList>
    )
}

export default PropertySelectorController
